import { Palette, ThemeConfiguration } from 'mm-theme-configuration/dist/interfaces';
import { AdSlots } from 'mm-client-core';
import { Image } from '../template/template.state.types';

interface Theme {
    palette: Palette;
    themeConfiguration: ThemeConfiguration;
}

interface ExternalScript {
    async: true | false;
    name: string;
    source: string;
    type: string;
}
export type ExternalScripts = Array<ExternalScript>;

export interface ConfigState {
    title: string;
    image: Image | null;
    externalScripts: ExternalScripts;
    facebookAppId: string | null;
    facebookPageId: string | null;
    description: string;
    siteName: string;
    canonicalURL: string;
    favicon: string;
    language: string;
    twitterAccount: string | null;
    template: string;
    logoUrl: string;
    theme: Theme;
    adSlots: AdSlots;
    category: string | null;
    headerBidderPublisherID: string;
    imagesCDNHost: string;
    ampURL: string | null;
    prevCanonicalUrl: string | null;
    dfpProperty: string;
    pagePath: string;
    propertyEndpoint: string;
    pageType: string;
    timeZone: string;
    locale: string;
    midnightInTimeZone: string;
}

export const configReducer = (state: ConfigState = {} as ConfigState, action: {type: string}) => {
    switch (action.type) {
    default:
      return state;
  }
};
